import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { CORP_BLUE } from 'config/config';
import { asignarProrroga /* obtenerArchivoPreviewAdjuntoPorSuper */ } from 'services/api';
import { Preview } from '@mui/icons-material';
import RenderFile from 'customComponents/RenderFile';
import { toast } from '@jumbo/components/custom/Toast';
import { daysToDate } from '@jumbo/utils/dateHelper';

const addStyle = makeStyles(theme => ({
  previewStyle: {
    color: 'black',
    cursor: 'pointer',
    padding: 2,
    '&:hover': {
      color: CORP_BLUE,
    },
  },
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    backgroundColor: CORP_BLUE,
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: 'white',
    },
  },
  num: {
    display: 'block',
    width: '100%',
  },
}));

const defaultReclamo = {
  n_reclamo: '',
};

const ModalProrroga = props => {
  const { openDialog = false, close, reclamo = defaultReclamo, reload, setReload } = props;
  const classes = addStyle();
  /*   const [num, setNum] = useState(''); */
  const [numTraslado, setNumTraslado] = useState('');
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [getInfoShown, setGetInfoShown] = useState(0);
  const [url, setUrl] = useState('');
  const [showOficioProrroga, setShowOficioProrroga] = useState(false);
  const [reclamado, setReclamado] = useState('');
  const [fecha, setFecha] = useState('');

  const startPreview = () => {
    setShowOficioProrroga(true);
  };

  useEffect(() => {
    if (reclamo) {
      /*    setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo'); */
      setReclamado(reclamo.reclamado);
      setFecha(reclamo.fecha_traslado ? reclamo.fecha_traslado : 'N/A');
      setNumTraslado(reclamo.num_traslado ? reclamo.num_traslado : 'N/A');
    }
  }, [reclamo]);

  const onCloseDialog = event => {
    close();
    setGetInfoShown(0);
    setLoading(false);
  };

  const getView = () => {
    if (getInfoShown === 0) {
      return infoView();
    }

    if (getInfoShown === 1) {
      return resultView();
    }
  };

  const fechaHoy = () => {
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];

    const hoy = new Date();
    const dia = hoy.getDate().toString().padStart(2, "0");
    const mes = meses[hoy.getMonth()];
    const anio = hoy.getFullYear();

    return `${dia} de ${mes} de ${anio}`;
  }



  const infoView = () => {
    return (
      <Grid container item>
        <Grid container justifyContent='flex-end' item xs={12}>
          <p>Santiago, {fechaHoy()} </p>
        </Grid>
        <Grid item xs={12}>
          <p>De mi consideración: </p>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
          <p style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
            Por medio de la presente me permito saludarle y, a su vez, solicitarle muy respetuosamente, en relación con el
            Ord. IP/N°
            {numTraslado} de fecha {fecha}, notificado a este establecimiento, tenga a bien otorgarnos un aumento de plazo
            para dar respuesta a lo solicitado en el Ordinario recién mencionado.
          </p>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
          <p style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
            Lo anterior en virtud de lo dispuesto en la Ley Nº19.880 que establece las Bases de los Procedimientos
            Administrativos que rigen los actos de los órganos de la Administración del Estado, el que en su artículo 26
            dispone que la Administración, podrá conceder, de oficio o a petición de los interesados, una ampliación de los
            plazos establecidos.
          </p>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
          <p style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
            Esta solicitud tiene como único fundamento, el poder recabar los antecedentes clínicos y administrativos
            suficientes, a efectos de responder a vuestra autoridad y dar cumplimiento a lo solicitado.
          </p>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
          <p>Sin otro particular, y agradeciéndole su comprensión, le saluda atentamente.</p>
          <br></br>
        </Grid>
        {/*         <Grid item xs={12} style={{marginTop:10, textAlign:'center'}} >
          <p>nombre direcor o reporesntante legal</p>
        </Grid> */}
        <Grid item xs={12} style={{ marginTop: 10, textAlign: 'center' }}>
          <p>Director Médico - Representante Legal</p>
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 15, textAlign: 'center', fontWeight: 'bold' }}>
          <p>{reclamado}</p>
        </Grid>
      </Grid>
    );
  };

  const resultView = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        <Grid container>
          <Grid item xs={10}>
            {/* Solicitud de prórroga realizada, el oficio fue generado. */}
            {"Solicitud de prórroga generada con éxito, para revísar ingrese al reclamo, sección Adjuntos -> Documentos aportados por el prestador."}
          </Grid>
{/*           <Grid item xs={2}>
            <Preview
              onClick={() => {
                startPreview();
              }}
              className={classes.previewStyle}
              style={{ fontSize: 34, padding: 2 }}
            />
          </Grid> */}
        </Grid>
      </Box>
    );
  };

  const loadingView = () => {
    return (
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
        Realizando solicitud de prórroga.
      </Box>
    );
  };

  const onSubmitClick = () => {
    setLoading(true);
    let data = {
      n_reclamo: reclamo.n_reclamo,
      run_rec: reclamo.run_rec,
      fecha_ingreso: reclamo.fecha_ingreso
    };

    asignarProrroga(data)
      .then(res => {
        if (res.status === 200) {
          //setUrl(res.data);
          setGetInfoShown(1);
        }
        if (res.status === 202) {
          toast.error(res.data.message);
        }
      })
      .catch(err => {
        toast.warning('Ocurrió un error.');
        console.error(err);
      })
      .finally(e => {
        setLoading(false);
        setReload(!reload);
      });
  };

  const closeOficio = () => {
    setShowOficioProrroga(false);
  };

  const getReclamoView = () => {
    if (reclamo.fecha_vencimiento === '') {
      return (
        <DialogContent dividers>
          {/* aca van las vistas */}
          {loading ? loadingView() : getView()}
          {getInfoShown === 0 ? (
            <Box display="flex" justifyContent="flex-end" mb={4}>
              <Button onClick={onCloseDialog} disabled={loading}>
                &nbsp;Cancelar&nbsp;
              </Button>
              <Box ml={2}>
                <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
                  {loading ? (
                    <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} />
                  ) : (
                    'Aceptar y Enviar'
                  )}
                </Button>
              </Box>
            </Box>
          ) : (
            <Box display="flex" justifyContent="flex-end" mb={4}>
              <Button onClick={onCloseDialog} disabled={loading} variant="contained" color="primary">
                &nbsp;Cerrar&nbsp;
              </Button>
            </Box>
          )}
        </DialogContent>
      );
    } else {
      if (daysToDate(reclamo.fecha_vencimiento) < 0) {
        return (
          <DialogContent dividers>
            <Grid container item>
              <Grid item xs={12}>
                <p>El periodo de solicitud de prórroga expiró</p>
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="flex-end" mb={4}>
              <Button onClick={onCloseDialog} disabled={loading}>
                &nbsp;Cerrar&nbsp;
              </Button>
            </Box>
          </DialogContent>
        );
      } else {
        return (
          <DialogContent dividers>
            {/* aca van las vistas */}
            {loading ? loadingView() : getView()}
            {getInfoShown === 0 ? (
              <Box display="flex" justifyContent="flex-end" mb={4}>
                <Button onClick={onCloseDialog} disabled={loading}>
                  &nbsp;Cancelar&nbsp;
                </Button>
                <Box ml={2}>
                  <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
                    {loading ? (
                      <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} />
                    ) : (
                      'Aceptar y Enviar'
                    )}
                  </Button>
                </Box>
              </Box>
            ) : (
              <Box display="flex" justifyContent="flex-end" mb={4}>
                <Button onClick={onCloseDialog} disabled={loading} variant="contained" color="primary">
                  &nbsp;Cerrar&nbsp;
                </Button>
              </Box>
            )}
          </DialogContent>
        );
      }
    }
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}>Solicitud de prórroga {/* Reclamo N° {num} */} </label>
      </DialogTitle>
      {reclamo ? getReclamoView() : null}
      {showOficioProrroga ? <RenderFile openDialog={showOficioProrroga} url={url} close={closeOficio} /> : null}
    </Dialog>
  );
};

export default ModalProrroga;
